var React = require( 'react' );
var createReactClass = require('create-react-class');
var DropDownList = require('./dropDownList.jsx');

var StatePicker = createReactClass({
  getInitialState: function() {
    return {
      usStates: [     
        {"id": 1, "value": "1", "title": "Alabama"},
        {"id": 2, "value": "2", "title": "Alaska"},
        {"id": 3, "value": "3", "title": "Arizona"},
        {"id": 4, "value": "4", "title": "Arkansas"},
        {"id": 5, "value": "5", "title": "California"},
        {"id": 6, "value": "6", "title": "Colorado"},
        {"id": 7, "value": "7", "title": "Connecticut"},
        {"id": 8, "value": "8", "title": "Delaware"},
        {"id": 9, "value": "9", "title": "District of Columbia (DC)"},
        {"id": 10, "value": "10", "title": "Florida"},
        {"id": 11, "value": "11", "title": "Georgia"},
        {"id": 12, "value": "12", "title": "Hawaii"},
        {"id": 13, "value": "13", "title": "Idaho"},
        {"id": 14, "value": "14", "title": "Illinois"},
        {"id": 15, "value": "15", "title": "Indiana"},
        {"id": 16, "value": "16", "title": "Iowa"},
        {"id": 17, "value": "17", "title": "Kansas"},
        {"id": 18, "value": "18", "title": "Kentucky"},
        {"id": 19, "value": "19", "title": "Louisiana"},
        {"id": 20, "value": "20", "title": "Maine"},
        {"id": 21, "value": "21", "title": "Maryland"},
        {"id": 22, "value": "22", "title": "Massachusetts"},
        {"id": 23, "value": "23", "title": "Michigan"},
        {"id": 24, "value": "24", "title": "Minnesota"},
        {"id": 25, "value": "25", "title": "Mississippi"},
        {"id": 26, "value": "26", "title": "Missouri"},
        {"id": 27, "value": "27", "title": "Montana"},
        {"id": 28, "value": "28", "title": "Nebraska"},
        {"id": 29, "value": "29", "title": "Nevada"},
        {"id": 30, "value": "30", "title": "New Hampshire"},
        {"id": 31, "value": "31", "title": "New Jersey"},
        {"id": 32, "value": "32", "title": "New Mexico"},
        {"id": 33, "value": "33", "title": "New York"},
        {"id": 34, "value": "34", "title": "North Carolina"},
        {"id": 35, "value": "35", "title": "North Dakota"},
        {"id": 36, "value": "36", "title": "Ohio"},
        {"id": 37, "value": "37", "title": "Oklahoma"},
        {"id": 38, "value": "38", "title": "Oregon"},
        {"id": 39, "value": "39", "title": "Pennsylvania"},
        {"id": 40, "value": "40", "title": "Rhode Island"},
        {"id": 41, "value": "41", "title": "South Carolina"},
        {"id": 42, "value": "42", "title": "South Dakota"},
        {"id": 43, "value": "43", "title": "Tennessee"},
        {"id": 44, "value": "44", "title": "Texas"},
        {"id": 45, "value": "45", "title": "Utah"},
        {"id": 46, "value": "46", "title": "Vermont"},
        {"id": 47, "value": "47", "title": "Virginia"},
        {"id": 48, "value": "48", "title": "Washington"},
        {"id": 49, "value": "49", "title": "West Virginia"},
        {"id": 50, "value": "50", "title": "Wisconsin"},
        {"id": 51, "value": "51", "title": "Wyoming"}
      ]
    };
  },

  handleChange: function(value, event) {  
    var userResponse = {
        tag: 'state',
        text: (event && event.target[value].text),
        value: (event && event.target.value)
    };
    this.props.response(userResponse);
  },  

  render: function(){
    return (
        <div className="row">
            <div className="column small-4 small-offset-4">        
                <DropDownList
                  list={this.state.usStates}
                  value={this.props.value}
                  onChange={this.handleChange}
                  placeholder="Select state..." />
            </div>
        </div>                  
    );
  }
});

module.exports = StatePicker;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/pickers/statePicker.jsx